import { InformalFeedbackReview } from 'api/clients/InformalFeedbackRequestsClient'
import Styles from './ReviewerCard.module.scss'
import { Text, TextVariant } from 'blaze-ui/Text/Text'
import { reviewResult } from '../utils'

interface Props {
  review: InformalFeedbackReview
  variant?: TextVariant
}

export const ReviewerScore = ({ review, variant = 'label' }: Props) => {
  const reviewResultKey = review.score || review.dismissed_reason
  const reviewScore = reviewResultKey && reviewResult[reviewResultKey]

  if (!reviewScore) return null

  return (
    <div className={Styles.reviewResult}>
      {reviewScore.iconSmall}
      <Text variant={variant} color={reviewScore.color}>
        {reviewScore.label}
      </Text>
    </div>
  )
}
